import { Avatar, Button, Tag, Tooltip, Typography } from "antd";
import { BankData } from "../../Data/BankData";
import { tagsBageStatus } from "../../helpers/tagsBage";
import { CopyOutlined, EyeOutlined, EyeTwoTone } from "@ant-design/icons";
import { CopyTextToClipboard } from "../../helpers/copy";
import { FormatTimeAgo } from "../../helpers/formatTimeAgo";
import { splitTransactionRef } from "../../utils";
const { Text } = Typography;
export const ColumnsVerifySlip = (
  t,
  handleShow,
  handleShowModelDetelCustomer,
  accessible_details,
  accessible_details_customer
) => [
    // ID
    {
      title: "#",
      render: (text, record, index) => <span
        style={{ cursor: "pointer", color: "#767474", width: 70 }}
        className="hover"
        onClick={() => accessible_details ? handleShow(record) : alert(t("You don't have permission to view details"))}
      >
        <u >#{index + 1}</u>
      </span>,
    },

    {
      title: t("TransRef"),
      key: "transRef",
      dataIndex: "transRef",
      render: (ref) => (
        <>
          <div className="hover text-truncate" title={ref} style={{ color: "#3eacff", maxWidth: 100, cursor: "copy" }} onClick={() => CopyTextToClipboard(ref)}>{ref}</div>
        </>
      ),
    },

    // createdAt
    {
      title: t("createdAt"),
      dataIndex: "createdAt",
      key: "createdAt",
      sorter: false,
      render: (date) => {
        return <>{FormatTimeAgo(date)}</>;
      },
    },

    // Sender
    {
      title: t("Sender"),
      sorter: false,
      render: (_, record) => {
        let senderBank = record?.senderBank || null;
        let senderName = record?.senderName || null;
        let senderAccountNo = record?.senderAccountNo || null;

        const iconBank = (code) => {
          if (!code) return null;
          let bank = BankData.find((i) => i.bankCode === code);
          if (!bank) return null;
          return { ...bank };
        };

        let bankInfo = iconBank(senderBank);
        let bankImg = bankInfo?.bankLogo;
        let bankName = t(bankInfo?.bank_id);
        return (
          <>
            <span>
              <Avatar size={24} alt={bankName} src={bankImg} />
              {" - "}
              <>

                <span className="hover">{senderAccountNo}{" "}<CopyOutlined
                  className="hover"
                  style={{ cursor: "copy" }}
                  onClick={() => CopyTextToClipboard(senderAccountNo)}
                /></span>

              </>{" "}
              <br />{" "}
              <b>
                <Tooltip color="blue" title={t("Customer details")}>
                  <span className="hover" style={{ cursor: "pointer" }} onClick={() => {
                    if (accessible_details_customer) {
                      handleShowModelDetelCustomer(record);
                    } else {
                      alert(t("You don't have permission to view customer details"));
                    }
                  }}>
                    <EyeTwoTone /> {senderName}
                  </span>{" "}
                </Tooltip>{" "}
                <CopyOutlined
                  style={{ cursor: "copy" }}
                  className="hover"
                  onClick={() => CopyTextToClipboard(senderName)}
                />
              </b>
            </span>
          </>
        );
      },
    },

    // Receiver
    {
      title: t("Receiver"),
      sorter: false,
      render: (_, record) => {
        let receiverBank = record?.receiverBank || null;
        let receiverName = record?.receiverName || null;
        let receiverAccountNo = record?.receiverAccountNo || null;

        const iconBank = (code) => {
          if (!code) return null;
          let bank = BankData.find((i) => i.bankCode === code);
          if (!bank) return null;
          return { ...bank };
        };

        let bankInfo = iconBank(receiverBank);
        let bankImg = bankInfo?.bankLogo;
        let bankName = t(bankInfo?.bank_id);
        return (
          <span>
            <Avatar size={24} alt={bankName} src={bankImg} />
            {" - "}
            <>{receiverAccountNo}</> <br /> <b>{receiverName}</b>
          </span>
        );
      },
    },

    // Amount
    {
      title: t("Amount"),
      dataIndex: "amount",
      key: "amount",
      sorter: false,
      render: (amount) => {
        let amt = Intl.NumberFormat().format(amount || 0);
        return <b>{amt}.-</b>;
      },
    },

    // Status
    {
      title: t("Status"),
      dataIndex: "status",
      key: "status",
      sorter: false,
      render: (status) => {
        return (
          <Tag color={tagsBageStatus(status)} key={status}>
            {status ? t(status.toUpperCase()) : t("N/A")}{" "}
            {/* Localize status text */}
          </Tag>
        );
      },
    },

    // Column Note
    {
      title: t("note"),
      dataIndex: "note",
      key: "note",
      sorter: false,
      render: (note, record) => {
        // เรียกใช้ฟังก์ชันแยกส่วน
        const { p1, p2 } = splitTransactionRef(note);

        return (
          <div
            className="text-wrap"
            style={{ fontSize: 11, maxWidth: 250 }}
          >
            {/* ส่วนที่ 1: ข้อความหลัก (เช่น "พบรายการสลิปซ้ำ") */}
            <div style={{ fontWeight: p2 ? 'bold' : 'normal', marginBottom: p2 ? 4 : 0 }}>
              {t(p1)}
            </div>

            {/* ส่วนที่ 2: ส่วนของ Ref (ถ้ามีจะขึ้นบรรทัดใหม่และสีจางลง) */}
            {p2 && (
              <div className="hover" style={{ fontSize: 10, color: "#8c8c8c", display: "inline-flex", alignItems: "center", gap: 4 }}>
                <code style={{ fontWeight: p2 ? 'bold' : 'normal', color: "#8c8c8c" }}>{t("dupRef")}:</code>
                <code style={{ fontSize: 10, color: "#3eacff", }} >{record.transRef}</code> <Text style={{ color: "#3eacff", fontSize: 11 }} copyable={{ text: record.transRef, tooltips: false }} />
              </div>
            )}
          </div>
        );
      },
    },

    {
      title: t("ทำรายการโดย"),
      sorter: false,
      render: (record) => {
        let admin = record?.Admin || null;
        return <b><small>{admin ? admin?.username : "-"}</small></b>;
      },
    },

    // action
    {
      title: t("action"),
      render: (_, record) => {
        return (
          <>
            <Button
              shape="circle"
              type="default"
              size="middle"
              onClick={() => accessible_details ? handleShow(record) : alert(t("You don't have permission to view details"))}
              icon={<EyeOutlined />}
              title={t("Details")}
            />
          </>
        );
      },
    },
  ];
